<template>
  <v-data-table
    :headers="headers"
    :loading="loading"
    :items="fileInvoices"
    :search="search"
    @dblclick:row="handleClickRow"
    sort-by="id"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title
          >CADASTRO NOTAS FISCAIS PARA CONCILIAÇÃO</v-toolbar-title
        >
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" dark @click="AddNewInvoice()">
          <v-icon>mdi-plus</v-icon>
          Novo
        </v-btn>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-toolbar color="red lighten-1" dark class="text-h5"
              >Atenção</v-toolbar
            >
            <v-card-title class="text-h6">
              Tem certeza que deseja Deletar?
            </v-card-title>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Fechar</v-btn
              >
              <v-btn color="red darken-1" dark @click="deleteItemConfirm">
                <v-icon dark>mdi-delete</v-icon>
                Deletar
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogForm" max-width="950px">
          <v-card>
            <v-toolbar color="blue darken-2" dark class="text-h5"
              >Notas Fiscais para Conciliação</v-toolbar
            >
            <v-card-text class="pt-4">
              <v-row>
                <v-col>
                  <v-select
                    :items="companies"
                    :item-text="(item) => `${item.code} - ${item.name}`"
                    item-value="id"
                    label="Franqueado"
                    ref="franchise"
                    hide-details
                    clearable
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-row>
                    <v-col cols="12" xs="6" sm="8" md="6">
                      <v-subheader>Número / Série da Nota</v-subheader>
                    </v-col>
                    <v-col cols="12" xs="6" sm="4" md="6">
                      <div style="width: 100px; float: left">
                        <v-text-field
                          outlined
                          dense
                          hide-details
                          ref="number"
                        ></v-text-field>
                      </div>
                      <div style="width: 50px; float: left; margin-left: 10px">
                        <v-text-field
                          outlined
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    label="Data Emissão"
                    ref="issue_date"
                    append-outer-icon="mdi-calendar"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-file-input
                    accept="image/*"
                    label="Nota Fiscal"
                    hide-details
                    dense
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogForm = false"
                >Fechar</v-btn
              >
              <v-btn color="green darken-1" dark @click="dialogForm = false"
                >Confirmar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.created_at="{ item }">
      {{ item.created_at | datetimeFormatBr }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.updated_at="{ item }">
      {{ item.updated_at | datetimeFormatBr }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.status="{ item }">
      <v-chip :color="getColor(item.status)" dark>
        {{ getLabel(item.status) }}
      </v-chip>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.actions="{ item }">
      <v-tooltip top color="blue darken-1">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="mr-2"
            color="blue darken-1"
            @click="editItem(item)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-pencil
          </v-icon>
        </template>
        <span>Editar</span>
      </v-tooltip>
      <v-tooltip top color="error">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            color="red darken-1"
            @click="deleteItem(item)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-delete
          </v-icon>
        </template>
        <span>Deletar</span>
      </v-tooltip>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize"> Recarregar </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import * as API from "@/api/requests/CestRequest";
import * as CompanyAPI from "@/api/requests/CompanyRequest";

export default {
  data: () => ({
    dialogDelete: false,
    dialogForm: false,
    search: "",
    loading: false,
    companies: [],
    headers: [
      {
        text: "ID",
        align: "right",
        value: "id",
        width: 50,
      },
      { text: "Número Nota", value: "code", width: 100 },
      { text: "Data Emissão", value: "name", width: 100 },
      { text: "Franquia/Multimarca", value: "created_at", width: 300 },
      { text: "Data Cadastro", value: "created_at", width: 150 },
      {
        text: "Ação",
        value: "actions",
        sortable: false,
        width: 100,
        align: "right",
      },
    ],
    fileInvoices: [],
    editedItem: {
      name: "",
      status: 1,
    },
    defaultItem: {
      name: "",
      status: 1,
    },
  }),

  computed: {},

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.getCompanies();
      // this.getCests();
    },
    async getCompanies() {
      this.loading = true;
      try {
        let data = await CompanyAPI.getAll("?type=fra,mul");
        this.companies = data.sort((a, b) => (a.code > b.code ? 1 : -1));
      } catch (error) {
        this.companies = [];
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    getColor(status) {
      return status == 1 ? "green" : "red";
    },
    getLabel(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },

    async getCests() {
      this.loading = true;
      this.cests = [];
      try {
        this.cests = await API.getAll();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    editItem(item) {
      this.$router.push({ name: "CestEdit", params: { id: item.id } });
    },
    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.loading = true;
      this.cests = [];
      try {
        await API.destroy(this.editedItem.id);
        this.loading = false;
        this.initialize();
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
    handleClickRow(event, item) {
      this.editItem(item.item);
    },
    AddNewInvoice() {
      this.dialogForm = true;
    },
  },
};
</script>
